<template>
  <div class="widget-empty">
    <!-- Silence is golden. -->
  </div>
</template>

<style lang="scss" scoped>
.widget-empty {
  color: #ccc;
  text-align: center;
  padding: 50px;
}
</style>

<script>
export default {
  name: 'EmptyWidget'
}
</script>
